<template>
    <div class="category-pages">
        <PageHeader></PageHeader>
        <img src="../assets/home1.jpg" alt="" />
        <img src="../assets/home6.jpg" alt="" />
        <van-tabs v-model="active" animated>
            <van-tab title="男生">
                <van-divider><van-icon name="star"/>男生<van-icon name="star"/></van-divider>
                <ul class="category">
                    <CategoryCardItem v-for="(item, index) in maleCategory" :key="index" :item="item"></CategoryCardItem>
                </ul>
            </van-tab>
            <van-tab title="女生">
                <van-divider><van-icon name="star"/>女生<van-icon name="star"/></van-divider>
                <ul class="category">
                    <CategoryCardItem v-for="(item, index) in femaleCategory" :key="index" :item="item"></CategoryCardItem>
                </ul>
            </van-tab>
            <van-tab title="出版">
                <van-divider><van-icon name="star"/>出版<van-icon name="star"/></van-divider>
                <ul class="category">
                    <CategoryCardItem v-for="(item, index) in publishCategory" :key="index" :item="item"></CategoryCardItem>
                </ul>
            </van-tab>
            <van-tab title="标签">
                <van-divider><van-icon name="star"/>标签<van-icon name="star"/></van-divider>
                <ul class="category">
                    <CategoryCardItem v-for="(item, index) in labelCategory" :key="index" :item="item"></CategoryCardItem>
                </ul>
            </van-tab>
        </van-tabs>
    </div>
</template>

<script>
import PageHeader from "@/components/PageHeader.vue";
import CategoryCardItem from "@/components/CategoryCardItem.vue";

export default {
    data() {
        return {
            active: 0,
            maleCategory: null,
            femaleCategory: null,
            publishCategory: null,
            labelCategory: null
        };
    },
    components: {
        PageHeader,
        CategoryCardItem
    },
    methods: {
        getCategoryCard() {
            this.axios.get("https://novel.kele8.cn/categories").then(response => {
                this.$toast.loading({ message: "加载中...", forbidClick: true, loadingType: "spinner" });
                window.console.log(response.data);
                ({ male: this.maleCategory } = response.data);
                ({ female: this.femaleCategory } = response.data);
                ({ picture: this.labelCategory } = response.data);
                ({ press: this.publishCategory } = response.data);
            }).finally(this.$toast.clear());
        }
    },
    created() {
        this.getCategoryCard();
    }
};
</script>

<style lang="less">
.category-pages {
    margin-bottom: 70px;
    & > img {
        width: 45%;
        margin: 15px 5px 0;
    }
    .van-divider {
        margin: 10px 0;
        .van-icon {
            transform: scale(0.5);
            font-size: 10px;
            color: lightgray;
            &:first-child {
                margin-right: 15px;
            }
            &:last-child {
                margin-left: 15px;
            }
        }
    }
    .van-tab--active {
        color: #323233;
        font-weight: 600;
    }
    .van-tab {
        font-size: 16px;
        font-weight: 600;
    }
}
</style>
